import { render, staticRenderFns } from "./FormaPagamentoPadrao.vue?vue&type=template&id=4b1ad987&scoped=true&"
import script from "./FormaPagamentoPadrao.vue?vue&type=script&setup=true&lang=js&"
export * from "./FormaPagamentoPadrao.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1ad987",
  null
  
)

export default component.exports